import { inject } from '@angular/core';
import { LocalStorageService } from './services/local-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { environment } from './environment';

export const intializeAppFn = () => {
  return new Promise<any>(async (resolve) => { 
    const storageService = inject(LocalStorageService);  
    const  translate = inject(TranslateService);      
    try {
        let userBrowserLanguageCode = (translate.getBrowserLang() ?? translate.getFallbackLang() ?? 'en').trim().toString().toUpperCase();

        let langaugeCode = await firstValueFrom(storageService.get(storageService.userLangaugeCodeKey),{ defaultValue: null });
        let userSelectedLangaugeCode = langaugeCode ? (langaugeCode+'').trim().toString().toUpperCase() : userBrowserLanguageCode;
        if(!environment.AppLanguageCodes.includes(userSelectedLangaugeCode)){
          userSelectedLangaugeCode = environment.AppDefaultLanguageCode;
        }

        const responseText = await fetch(`${environment.apiBaseUrl}appkey/${environment.MERCHANT_KEY}`).then(r => r.text());
        const splitArray = responseText.split("{R2#$}").map(m => m.split('').reverse().join(''));
        const middleArray = Array.isArray(splitArray) ? splitArray.reverse() : [];
        const finalString = ["-----BEGIN RSA PUBLIC KEY-----", ...middleArray, "-----END RSA PUBLIC KEY-----"].join("\r\n");      
        storageService.setKey(finalString); 
       
        storageService.set(storageService.userLangaugeCodeKey, userSelectedLangaugeCode).subscribe();        
        translate.use(userSelectedLangaugeCode.toLowerCase());        
        resolve(true);  
    } catch (error) {
      //console.log('Failed to load remote environment', error);
      resolve(true);    
    }    
       
  })   
}

